export default __webpack_public_path__ + "static/media/FreshAirOn.87c37b37.svg";